// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"OurBeliefs_wrapper__DrtvZ","title":"OurBeliefs_title__xNyOy","text":"OurBeliefs_text__Hslf_"};